// extracted by mini-css-extract-plugin
module.exports = {"edit":"Edit_edit__3zdqP","dialog":"Edit_dialog__2rZet","status":"Edit_status__2PVqm","buttons":"Edit_buttons__2c6YF","fadeIn":"Edit_fadeIn__36Ir4","fadeOut":"Edit_fadeOut__1eKbX"};